import { createHttpLink } from '@apollo/client';

import { env } from '@/config/env';

/**
 * Points at the Platform Gateway, never at Willnq.Api directly (ADR-0010,
 * docs/development/FrontendGuidelines.md §12.6). `credentials: 'include'` keeps GraphQL calls credential-aware,
 * consistent with the REST client. The `HttpOnly` refresh cookie (ADR-0006) is scoped to `Path=/auth`,
 * so it is never actually attached to `/graphql` requests — GraphQL neither needs nor sees it.
 */
export const httpLink = createHttpLink({
  uri: env.graphqlUrl,
  credentials: 'include',
});
